import { SurveyAnswerInterface } from '@elearning-platform/api-types/interfaces';

export const extractAnswerValue: (answers: SurveyAnswerInterface[]) => string | undefined
= (answers: SurveyAnswerInterface[]): string | undefined => {
  const hasSelectedType: boolean = answers.some((answer: SurveyAnswerInterface): boolean => answer.type === 'selected');

  if (hasSelectedType) {
    return answers.find((answer: SurveyAnswerInterface): boolean => answer.selected)?.answer;
  }

  return answers.find((answer: SurveyAnswerInterface): boolean => answer.editable)?.answer;
};
